<template>
  <base-select
    :model-value="modelValue"
    :label="$t('WithdrawToCard | paymentMethodLabel')"
    :options="preparedOptions"
    :placeholder="$t('WithdrawToCard | paymentMethodPlaceholder')"
    @update:modelValue="handleMethodChange"
  >
    <template v-if="activeOption" #trigger>
      <div class="payment-method-trigger">
        <svg-icon :name="activeOption?.icon" class="payment-method-icon" />
        <div class="payment-method-title">
          {{ $t(activeOption?.title) }}
        </div>
      </div>
    </template>

    <template #item="{ data }">
      <div class="payment-method-item">
        <svg-icon :name="data?.icon" class="payment-method-icon" />
        <div class="payment-method-title">
          {{ $t(data?.title) }}
        </div>
      </div>
    </template>
  </base-select>
</template>

<script>
import BaseSelect from '@emcd-shared/base-select'
import SvgIcon from '@/shared/ui/SvgIcon/SvgIcon.vue'

export default {
  components: {
    BaseSelect,
    SvgIcon,
  },

  props: {
    // Id of the selected option
    modelValue: {
      required: true,
    },

    // Array of all available paymentMethods descriptions
    options: {
      type: Array,
      default: () => [],
    },
  },

  emits: ['update:modelValue'],

  computed: {
    // Return enriched information for the selected payment method or undefined
    activeOption() {
      return this.options.find((option) => option.value === this.modelValue)
    },

    // Augmented and sorted options array
    preparedOptions() {
      if (!this.options) return []

      return this.options.map((option) => ({
        ...option,
        optionValue: option.value, // BaseSelect expects optionValue
      }))
    },
  },

  methods: {
    handleMethodChange(value) {
      this.$emit('update:modelValue', value)
    },
  },
}
</script>

<style scoped lang="scss">
.payment-method-trigger,
.payment-method-item {
  display: flex;
  align-items: center;
  gap: 15px;
}
</style>
